import type { NavigateFunction } from "react-router";
import { setLang, useLang, useT } from "../i18n";
import { useApp } from "../store";
import { updateUser } from "../sync/actions";
import { Menu } from "../ui/primitives";
import { applyTheme, currentThemeSetting } from "./theme";

export function UserMenu({
  anchor,
  onClose,
  onNavigate,
}: {
  anchor: Element | null;
  onClose: () => void;
  onNavigate: NavigateFunction;
}) {
  const t = useT();
  const lang = useLang();
  const set = useApp((s) => s.set);
  const logout = useApp((s) => s.logout);
  if (!anchor) return null;
  const theme = currentThemeSetting();
  const nextTheme = theme === "dark" ? "light" : "dark";
  return (
    <Menu
      anchor={anchor}
      onClose={onClose}
      items={[
        { key: "settings", label: t("settings"), onSelect: () => set({ settingsOpen: "account" }) },
        {
          key: "theme",
          label: `${t("theme")}: ${t(theme)}`,
          onSelect: () => applyTheme(nextTheme),
        },
        {
          key: "lang",
          label: `${t("language")}: ${lang === "zh" ? "中文" : "English"}`,
          onSelect: () => {
            const next = lang === "zh" ? "en" : "zh";
            setLang(next);
            void updateUser({ lang: next === "zh" ? "zh_CN" : "en" });
          },
        },
        { key: "shortcuts", label: t("shortcuts"), onSelect: () => set({ shortcutsOpen: true }) },
        { key: "sep", label: "", separator: true },
        {
          key: "logout",
          label: t("logout"),
          danger: true,
          onSelect: () => {
            void logout().then(() => onNavigate("/auth/login"));
          },
        },
      ]}
    />
  );
}
